module.exports = __webpack_public_path__ + "static/media/b-sci-major-4_LR.665457dc.jpg";